var map = {
	"./strings.GB.js": 132,
	"./strings.LV.js": 133,
	"./strings.RU.js": 134
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;


//////////////////
// WEBPACK FOOTER
// ./src/translations ^\.\/strings\..*\.js$
// module id = 131
// module chunks = 0